// extracted by mini-css-extract-plugin
export default {"footer":"yhAHIwA___footer","footer-link":"OyaWso3___footer-link","footerLink":"OyaWso3___footer-link"};